import { gsap } from 'gsap';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
export default {
    init() {
        // JavaScript to be fired on all pages

        $('.hamburger').click(function () {
            $(this).toggleClass('is-active');
            $('.menuMovil').toggleClass('verMovil');
        });




      gsap.registerPlugin(CSSRulePlugin);
      gsap.fromTo(
        '.wrap',
        {autoAlpha: 0},{duration: 1, autoAlpha: 1});




     /* $(document).on('mousemove',function(e) {
      $('.cursor').eq(0).css({
        left: e.pageX,
        top: e.pageY,
      });
      setTimeout(function(){
        $('.cursor').eq(1).css({
          left: e.pageX,
          top: e.pageY,
        });
      }, 100)

    });*/

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js